import { AllTimesRecordRow } from './exportAllTimeRecords'
import { downloadCsv } from '../../utils/csv/downloadCsv'
import {
  CSV_DELIMITER,
  serializeCsvRows,
} from '../../utils/csv/serializeCsvRows'

export type AllTimesHeaderLabels = {
  date: string
  teamMember: string
  client: string
  order: string
  position: string
  description: string
  internalNote: string
  tracked: string
  billable: string
  nonBillable: string
  status: string
}

type ExportAllTimesOptions = {
  records: AllTimesRecordRow[]
  rangeLabel: string
  headerLabels: AllTimesHeaderLabels
}

const formatHours = (hours: number): string =>
  String(Math.round(hours * 100) / 100)

const buildHeaderRow = (labels: AllTimesHeaderLabels): string[] => [
  labels.date,
  labels.teamMember,
  labels.client,
  labels.order,
  labels.position,
  labels.description,
  labels.internalNote,
  labels.tracked,
  labels.billable,
  labels.nonBillable,
  labels.status,
]

const toDataRow = (row: AllTimesRecordRow): string[] => [
  row.date,
  row.userName,
  row.clientName,
  row.orderName,
  row.positionName,
  row.description,
  row.internalNote,
  formatHours(row.totalDuration),
  formatHours(row.billableDuration),
  formatHours(row.nonBillableDuration),
  row.status,
]

export const exportAllTimesToCSV = ({
  records,
  rangeLabel,
  headerLabels,
}: ExportAllTimesOptions): boolean => {
  if (records.length === 0) {
    console.warn('No time records to export')
    return false
  }

  const rows: string[][] = [
    buildHeaderRow(headerLabels),
    ...records.map(toDataRow),
  ]

  downloadCsv({
    content: serializeCsvRows(rows, CSV_DELIMITER.TAB),
    fileName: `all-times-report-${rangeLabel}.csv`,
    withBom: true,
  })

  return true
}
